module.exports = __webpack_public_path__ + "static/media/statotech6.659c9bd3.png";